import React from "react";
import SkillCard from "./SkillCard";

const Frontend = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Frontend Developer</h3>

      <div className="skills__box">
        <div className="skills__group">
          <SkillCard name="HTML & CSS" level="Advanced" />
          <SkillCard name="Javascript" level="Intermediate" />
          <SkillCard name="Tailwind CSS" level="Intermediate" />
        </div>

        <div className="skills__group">
          <SkillCard name="Bootstrap" level="Intermediate" />
          <SkillCard name="React" level="Intermediate" />
          <SkillCard name="Git" level="Intermediate" />
        </div>
      </div>
    </div>
  );
};

export default Frontend;
